import React from 'react';
import './ProductDetailsNew.css';
import "./Textura.css";
import {
    Col,
    Row,
    Layout,
    Collapse,
    Image, Space,
} from 'antd';
import {Content} from "antd/es/layout/layout";
import {HOME_TEXT, PRODUCT_TEXT} from "../../text"
import {ProductDetailPageMeta} from "../../components/PageMeta/ProductDetailPageMeta";
import {TEXTURA_TEXT} from "../../text";
import {PlusOutlined, StarFilled} from "@ant-design/icons";
import {Reviews, ReviewCard} from "./Reviews";
import VerticalCarousel from "../../components/Carousel/VerticalCarousel";

const InstallsEasy_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/4+-+Made+For+You/installations.png";
const MadeForYou_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/4+-+Made+For+You/Textura+-+Frames+-+High+Res+-+Cropped.webp";
const Textura_App_product_review_Img_1 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/review1.png";
const Textura_App_product_review_Img_2 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/review2.png";
const Textura_App_product_review_Img_3 = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/review3.png";
const YouTubeLogo = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/youtube_logo.png";
const TexturaStars = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/stars.png";
const Vieunite_App_Vd2 = "https://d1mluz1pfkw29o.cloudfront.net/img/HomePage/7+-+Vieunite+App/phone2.webm";
const mLifeLike_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/3+-+Textura/Pine-mobile-tablet.webp";
const LifeLike_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/3+-+Textura/Pine-desktop.png";
const Transforming_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/2+-+Discover+the+World/Vieunite_Mockup_03_2.jpeg";
// Fake cards for testing
// Payment succeeds
// 4242 4242 4242 4242
// Payment requires authentication
// 4000 0025 0000 3155
// Payment is declined
// 4000 0000 0000 9995
const {Panel} = Collapse;

const PRICE = 599;
const maxLimitTop = '1250px'

const COLOR_CODE = {
    'a': 'Black',
    'b': 'Birch',
    'c': 'Pine',
    'd': 'Walnut',
}

const PrimaryFont = {
    fontFamily: "proxima-nova, sans-serif", fontWeight: '700',
}

const MWidth = {
    span: 20,
}

const TitleFont = {
    fontWeight: '700',
    fontSize: '2rem',
    fontFamily: "proxima-nova, sans-serif",
}

function scrollDown(id) {
    window.location = id;
    window.scrollBy(0, -100);
}

const makeMuted = (elt) => {
    if (elt) {
        elt.muted = true;
    }
};

class ProductDetailsNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            color: 'a', //a:black,b:birch,c:pine,d:walnut
        }
    }

    checkOut = () => {
        const color = this.state.color;
        //a:black,b:birch,c:pine,d:walnut
        if (color === 'a') {
            window.open("https://buy.stripe.com/fZe7sO2SufPpejK28e", '_blank');
        } else if (color === 'b') {
            // window.open("https://buy.stripe.com/14kdRc3WyeLl7VmaEM", '_blank');
            window.alert('Sorry, birch canvas is out of stock.')
        } else if (color === 'c') {
            window.open("https://buy.stripe.com/fZecN8gJkcDda3u5kt", '_blank');
        } else if (color === 'd') {
            window.open("https://buy.stripe.com/eVa28uct48mX5NefZ5", '_blank');
        } else {
        }
    }

    render() {
        return (
            <div>
                <ProductDetailPageMeta></ProductDetailPageMeta>
                <Layout style={{marginTop: '35px'}}>
                    <Content style={{background: "#f4f4f4"}}>

                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', padding: '0 8vw', margin: '1rem 0 0 0'}}>
                            <Row justify={"center"} style={{
                                // margin: '2vh 7vw 0 7vw',
                                // margin: '0 8vw',
                                width: '100%',
                                margin: 0,
                                maxWidth: maxLimitTop,
                                // backgroundColor: 'red'
                            }}>
                                <Col xs={24} lg={12} xl={6}>
                                    <div className={'pd-new-top-col'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="49" height="29" viewBox="0 0 49 29"
                                             fill="none">
                                            <g clip-path="url(#clip0_4_1401)">
                                                <path
                                                    d="M0 11.2945C0.382543 10.4668 1.03737 10.2146 1.92805 10.228C4.62215 10.2664 7.31817 10.2462 10.0132 10.2395C10.9931 10.2366 11.646 9.4934 11.5137 8.56219C11.413 7.85251 10.9576 7.47849 10.1264 7.47177C8.73904 7.45931 7.35173 7.46698 5.96441 7.46698C4.97593 7.46698 3.98746 7.47082 2.99802 7.46602C2.07762 7.46123 1.42854 6.85416 1.43717 6.01693C1.44484 5.19984 2.08721 4.60524 2.97885 4.59661C3.50137 4.59182 4.02293 4.59661 4.59339 4.59661C4.59339 3.55223 4.5886 2.55197 4.59435 1.5517C4.6001 0.591719 5.18974 0.00191805 6.15137 0.00191805C14.667 0 23.1827 0 31.6983 0H32.0559V0.52171C32.0559 3.13793 32.0559 5.75416 32.0559 8.36942C32.0559 9.4934 32.6082 10.0496 33.7232 10.0496C37.1834 10.0506 40.6445 10.0525 44.1046 10.0487C45.2388 10.0468 46.2743 10.3709 47.21 10.9952C48.3548 11.7586 48.954 12.8711 48.9732 14.2224C49.0153 17.2049 48.9971 20.1875 48.9866 23.171C48.9837 23.9843 48.3672 24.577 47.5504 24.5952C46.8332 24.6105 46.1151 24.6077 45.398 24.5952C45.1525 24.5904 45.0423 24.6604 44.9684 24.9117C44.2273 27.4282 42.1277 29.0211 39.6061 29.001C37.122 28.9808 35.0444 27.3418 34.3378 24.8484C34.3167 24.7736 34.2783 24.7026 34.2361 24.6H33.8133C29.2688 24.6 24.7234 24.6048 20.1789 24.5914C19.8098 24.5904 19.6755 24.6949 19.572 25.0555C18.8913 27.4214 16.7063 29.023 14.2432 29.001C11.8176 28.9789 9.67095 27.3332 9.00654 24.9836C8.97202 24.8628 8.93559 24.7429 8.8934 24.6C7.9845 24.6 7.09286 24.6029 6.20218 24.6C5.17631 24.5961 4.59723 24.0227 4.59435 23.0051C4.59051 21.7929 4.59435 20.5807 4.59435 19.3685C4.59435 19.2131 4.59435 19.0587 4.59435 18.8583C3.6749 18.8583 2.79956 18.819 1.92997 18.8688C1.03833 18.9197 0.383502 18.6329 0.000958754 17.8053V17.04C0.382543 16.2123 1.03833 15.9668 1.92805 15.9735C6.00851 16.0052 10.089 15.9841 14.1704 15.9908C14.8367 15.9918 15.3602 15.7674 15.6536 15.1507C16.1282 14.1552 15.3966 13.1185 14.2183 13.1176C10.1216 13.1137 6.02481 13.0984 1.92805 13.13C1.03833 13.1367 0.383502 12.8903 0.000958754 12.0636V11.2983L0 11.2945ZM11.6747 23.5163C11.6824 24.9683 12.8789 26.1373 14.3497 26.1287C15.7734 26.12 16.9441 24.9203 16.9354 23.4789C16.9268 22.0413 15.7408 20.8598 14.3123 20.8665C12.8463 20.8742 11.6671 22.0586 11.6747 23.5163ZM37.0319 23.4789C37.0242 24.9376 38.2016 26.12 39.6694 26.1287C41.097 26.1373 42.2839 24.9548 42.2926 23.5163C42.3012 22.0758 41.1315 20.877 39.7068 20.8665C38.238 20.8559 37.0395 22.0269 37.0319 23.4789Z"
                                                    fill="white"/>
                                                <path
                                                    d="M34.9434 7.15057V0.324219C38.881 1.07514 40.9864 3.89851 42.7869 7.15153H34.9434V7.15057Z"
                                                    fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4_1401">
                                                    <rect width="49" height="29" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <div className={'pd-new-top-div'}>
                                            <p className={'pd-new-top-p1'}>FREE WORLDWIDE SHIPPING</p>
                                            <p className={'pd-new-top-p2'}>Limited time only</p>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={24} lg={12} xl={6}>
                                    <div className={'pd-new-top-col'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38"
                                             fill="none">
                                            <g clip-path="url(#clip0_4_1408)">
                                                <path
                                                    d="M36.7392 38H33.252C33.252 31.7559 33.2381 25.5108 33.2659 19.2666C33.2708 18.2507 32.6404 17.4092 31.4133 17.4132C23.1414 17.439 14.8705 17.439 6.59867 17.4132C5.38045 17.4092 4.7411 18.2428 4.74605 19.2676C4.77381 25.5117 4.75993 31.7559 4.75993 38.001H1.27177C0.335057 37.6779 -0.00295428 37.0138 1.94288e-05 36.0366C0.0198441 28.6061 0.014888 21.1755 0.00299314 13.745C0.0020019 13.1117 0.22503 12.6815 0.747411 12.3237C6.53325 8.35129 12.3102 4.36595 18.0891 0.383577C18.8345 -0.129829 19.1844 -0.128838 19.9387 0.390515C25.6562 4.32927 31.3726 8.27101 37.095 12.2048C37.4648 12.4595 37.8018 12.7291 38.001 13.1404V36.7383C37.7948 37.3736 37.3736 37.7929 36.7392 38Z"
                                                    fill="white"/>
                                                <path
                                                    d="M20.3412 38.0007C19.9169 37.7648 19.791 37.4031 19.795 36.9253C19.8138 34.9847 19.802 33.0441 19.8029 31.1034C19.8029 30.3403 20.0646 30.0816 20.8299 30.0796C21.6556 30.0776 22.4813 30.0796 23.3645 30.0796C23.3645 30.4671 23.3615 30.82 23.3645 31.1728C23.3734 31.9409 23.8511 32.4544 24.55 32.4514C25.2409 32.4484 25.7236 31.9271 25.7365 31.1629C25.7424 30.819 25.7365 30.4741 25.7365 30.0796C26.0001 30.0796 26.2311 30.0796 26.4621 30.0796C27.1173 30.0796 27.7725 30.0697 28.4267 30.0836C28.9719 30.0945 29.2901 30.3968 29.293 30.9379C29.3039 33.0025 29.297 35.066 29.298 37.1305C29.298 37.5508 29.075 37.8174 28.7231 38.0007H20.3382H20.3412Z"
                                                    fill="white"/>
                                                <path
                                                    d="M9.28599 38.0006C8.84489 37.7845 8.70215 37.4228 8.70512 36.945C8.71801 35.0044 8.71008 33.0638 8.71107 31.1231C8.71107 30.354 8.98961 30.0805 9.76674 30.0795C10.5805 30.0785 11.3943 30.0795 12.2736 30.0795C12.2736 30.4957 12.2607 30.8853 12.2765 31.2738C12.3003 31.8397 12.6621 32.2956 13.1637 32.4225C13.6712 32.5513 14.2184 32.3432 14.4692 31.8784C14.5752 31.6811 14.6208 31.4373 14.6377 31.2094C14.6644 30.8545 14.6446 30.4967 14.6446 30.1221C14.7536 30.1052 14.8349 30.0814 14.9172 30.0805C15.7082 30.0775 16.4992 30.0725 17.2902 30.0805C17.9087 30.0864 18.2031 30.3778 18.2051 30.9913C18.2101 33.0182 18.1992 35.045 18.2131 37.0729C18.216 37.5139 18.0148 37.7875 17.6689 37.9996H9.28401L9.28599 38.0006Z"
                                                    fill="white"/>
                                                <path
                                                    d="M17.818 20.5894C17.818 21.0077 17.8121 21.3783 17.819 21.748C17.8329 22.4448 18.3404 22.9542 19.0095 22.9513C19.6786 22.9493 20.1772 22.4388 20.19 21.7371C20.197 21.3684 20.191 20.9987 20.191 20.5805C20.8205 20.5805 21.4222 20.5805 22.0238 20.5805C22.3331 20.5805 22.6434 20.5676 22.9506 20.5864C23.4482 20.6171 23.7476 20.9274 23.7496 21.4279C23.7555 23.5053 23.7555 25.5827 23.7496 27.6611C23.7476 28.1775 23.4284 28.4976 22.912 28.4986C20.303 28.5046 17.6941 28.5046 15.0842 28.4986C14.5866 28.4976 14.2605 28.1795 14.2595 27.6869C14.2516 25.5966 14.2525 23.5073 14.2595 21.417C14.2605 20.9472 14.539 20.6112 14.995 20.5973C15.9188 20.5696 16.8446 20.5894 17.818 20.5894Z"
                                                    fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4_1408">
                                                    <rect width="38" height="38" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <div className={'pd-new-top-div'}>
                                            <p className={'pd-new-top-p1'}>UK STOCK HELD</p>
                                            <p className={'pd-new-top-p2'}>All four frame options available</p>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={24} lg={12} xl={6}>
                                    <div className={'pd-new-top-col'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39"
                                             fill="none">
                                            <path
                                                d="M30.7334 12.8441C30.2058 13.3552 30.008 13.8828 30.0244 14.6083C30.0574 17.5266 30.0739 20.4615 30.0244 23.3798C30.0244 24.2207 30.2718 24.8143 30.8818 25.3913C32.5471 26.9907 34.1464 28.656 35.7952 30.2553C36.1744 30.6345 36.2239 30.8488 35.8117 31.2446C34.2783 32.7285 32.7779 34.2289 31.294 35.7622C30.8983 36.1744 30.6675 36.2074 30.2553 35.7622C28.557 34.0145 26.8258 32.3327 25.1275 30.6015C24.7318 30.2058 24.3196 30.0244 23.759 30.0244C22.1927 30.0574 20.6428 30.0244 19.0765 30.0244C17.5101 30.0244 15.9108 30.0244 14.3115 30.0244C13.8004 30.0244 13.4211 30.1893 13.0749 30.5356C11.3437 32.2833 9.59595 33.998 7.88121 35.7622C7.46901 36.1909 7.23818 36.1579 6.84247 35.7622C5.35856 34.2289 3.85817 32.7285 2.32479 31.2446C1.9126 30.8488 1.96206 30.6345 2.34128 30.2553C4.02305 28.6065 5.65535 26.9082 7.3536 25.2759C7.8977 24.7483 8.11204 24.2042 8.09555 23.4458C8.06258 20.5274 8.04609 17.5926 8.09555 14.6742C8.09555 13.8498 7.84824 13.2892 7.27116 12.7287C5.58939 11.1128 3.97358 9.43107 2.3083 7.79877C1.94557 7.43604 1.9126 7.23818 2.29182 6.85896C3.84168 5.35856 5.35856 3.82519 6.85896 2.29182C7.23818 1.89611 7.45253 1.86313 7.84824 2.29182C9.56298 4.05602 11.3107 5.75427 13.0419 7.51848C13.4211 7.8977 13.8169 8.06258 14.3445 8.06258C17.4937 8.04609 20.6428 8.04609 23.792 8.06258C24.3361 8.06258 24.7318 7.8977 25.0946 7.51848C26.8093 5.77076 28.5735 4.05602 30.2883 2.29182C30.684 1.87962 30.8983 1.9126 31.2775 2.29182C32.7779 3.84168 34.3113 5.35856 35.8447 6.85896C36.2239 7.23818 36.1909 7.43604 35.8282 7.79877C34.1299 9.46405 32.4811 11.1788 30.7664 12.8276M37.1967 8.75507C37.5099 8.4418 37.7738 8.09555 38.0705 7.74931V6.85896C35.8447 4.53417 33.5529 2.25884 31.2281 0.0164879H30.3377C29.975 0.346246 29.5793 0.643028 29.233 0.989273C27.5678 2.63806 25.9025 4.30334 24.2372 5.9851C23.9569 6.2654 23.6766 6.41379 23.2644 6.3973C20.445 6.38081 17.6091 6.38081 14.7896 6.3973C14.3774 6.3973 14.0971 6.2654 13.8169 5.9851C12.1186 4.25388 10.3874 2.53913 8.67263 0.824394C8.37585 0.527612 8.04609 0.280294 7.73282 0H6.84247C4.51768 2.24235 2.24235 4.53417 0 6.85896V7.74931C0.395709 8.32638 0.906834 8.78804 1.40147 9.28268C2.83592 10.7171 4.25388 12.1681 5.7213 13.586C6.19945 14.0477 6.41379 14.5093 6.3973 15.2018C6.34784 17.7739 6.34784 20.3625 6.3973 22.9347C6.3973 23.6107 6.19945 24.0723 5.7213 24.5505C4.089 26.1333 2.48967 27.7656 0.873858 29.3814C0.560588 29.6947 0.296782 30.0409 0 30.3707V31.261C2.22587 33.5858 4.51768 35.8776 6.84247 38.1035H7.73282C8.09555 37.7738 8.49126 37.477 8.83751 37.1307C10.5028 35.4655 12.1681 33.8002 13.8333 32.1349C14.1136 31.8546 14.3939 31.7062 14.8061 31.7227C17.6256 31.7392 20.4615 31.7392 23.2809 31.7227C23.6931 31.7227 23.9734 31.8546 24.2537 32.1349C25.9519 33.8661 27.6832 35.5809 29.3979 37.2956C29.6947 37.5924 30.0244 37.8397 30.3377 38.12H31.2281C33.5529 35.8941 35.8282 33.6023 38.0705 31.2775V30.3872C37.7408 30.0244 37.444 29.6287 37.0978 29.2825C35.449 27.6172 33.7837 25.9355 32.1019 24.2867C31.8216 24.0064 31.6732 23.7261 31.6897 23.3139C31.7062 20.4944 31.7062 17.6585 31.6897 14.8391C31.6897 14.4269 31.8216 14.1466 32.1019 13.8663C33.8167 12.1846 35.5149 10.4698 37.1967 8.77156"
                                                fill="white"/>
                                            <path
                                                d="M7.3209 6.15003C6.69436 6.15003 6.13377 6.72711 6.15026 7.35365C6.15026 7.99668 6.69436 8.5078 7.35387 8.5078C8.01339 8.5078 8.50802 7.99668 8.50802 7.32067C8.50802 6.66116 7.96392 6.13355 7.33738 6.15003"
                                                fill="white"/>
                                            <path
                                                d="M30.7333 6.1499C30.0902 6.1499 29.5791 6.694 29.5791 7.35352C29.5791 8.01303 30.0902 8.50767 30.7662 8.50767C31.4257 8.50767 31.9369 7.96357 31.9369 7.32054C31.9369 6.694 31.3598 6.1499 30.7333 6.1499Z"
                                                fill="white"/>
                                            <path
                                                d="M7.36997 29.5956C6.71045 29.5791 6.16635 30.0738 6.14986 30.7168C6.11689 31.3433 6.66099 31.9204 7.28753 31.9369C7.93055 31.9699 8.47465 31.4423 8.49114 30.7992C8.50763 30.1232 8.02948 29.6121 7.36997 29.5956Z"
                                                fill="white"/>
                                            <path
                                                d="M29.5795 30.7828C29.5795 31.4423 30.1236 31.97 30.7501 31.9535C31.3767 31.9535 31.9372 31.3764 31.9208 30.7499C31.9208 30.1068 31.3767 29.5957 30.7171 29.5957C30.0576 29.5957 29.563 30.1068 29.563 30.7828"
                                                fill="white"/>
                                            <path
                                                d="M26.9738 17.8727C26.9573 17.7244 26.9244 17.5595 26.8914 17.4111H26.1165C26.1165 17.4111 26.1 17.4111 26.0835 17.4111C26.5616 19.7689 26.0835 21.9123 24.5171 23.7424C22.9508 25.5726 20.9063 26.397 18.4991 26.2486C14.7068 26.0013 11.3103 22.5388 11.9039 18.0541C12.1677 16.1085 13.1075 14.5092 14.6739 13.3221C16.8503 11.6898 19.241 11.459 21.7802 12.3658C21.7802 12.102 21.7802 11.8382 21.7802 11.5579C21.7802 11.5414 21.7472 11.5084 21.7142 11.4919C21.0877 11.2611 20.4446 11.1127 19.7686 11.0632C19.6697 11.0632 19.5873 11.0468 19.4883 11.0303H18.565C18.4826 11.0303 18.3836 11.0468 18.2847 11.0632C16.8338 11.1952 15.5148 11.6733 14.3441 12.5307C12.7283 13.7013 11.6896 15.2677 11.2114 17.1967C11.129 17.5595 11.063 17.9387 11.03 18.3014C11.03 18.4004 11.0136 18.4828 10.9971 18.5817V19.505C10.9971 19.5875 11.0136 19.6864 11.03 19.7689C11.1455 21.1373 11.5906 22.3904 12.3656 23.5281C13.4208 25.078 14.8552 26.1332 16.6524 26.6938C17.0811 26.8257 17.5263 26.9246 17.9714 26.9741C18.1528 26.9906 18.3177 27.007 18.4991 27.0235C18.5155 27.0235 18.532 27.0235 18.5485 27.04H19.4718C19.5543 27.04 19.6532 27.0235 19.7357 27.007C21.2361 26.8751 22.5881 26.364 23.7752 25.4737C25.3086 24.3195 26.3143 22.8026 26.7925 20.9395C26.8914 20.5603 26.9573 20.1646 26.9903 19.7689C26.9903 19.6699 27.0068 19.5875 27.0233 19.505V18.5817V18.5488C27.0068 18.3179 26.9738 18.0871 26.9573 17.8563"
                                                fill="white"/>
                                            <path
                                                d="M17.8899 19.8349C16.8017 18.9611 15.7135 18.1037 14.6253 17.2299C14.1306 17.6256 13.6525 18.0213 13.1743 18.417C15.0704 20.3626 16.95 22.3081 18.8297 24.2702C18.8462 24.2372 18.8626 24.2042 18.8626 24.1877C19.011 23.858 19.1429 23.5117 19.3078 23.182C20.0663 21.6156 20.9896 20.1482 21.9788 18.7303C23.0011 17.2628 24.1058 15.8779 25.3424 14.5918C25.7546 14.1466 26.1997 13.7344 26.6119 13.3057C26.6284 13.2728 26.6614 13.2563 26.6449 13.2068C26.5295 12.9595 26.4306 12.6957 26.3152 12.4319C23.1 14.4599 20.3136 16.9496 17.8734 19.8185"
                                                fill="white"/>
                                        </svg>
                                        <div className={'pd-new-top-div'}>
                                            <p className={'pd-new-top-p1'}>WALL MOUNT INCLUDED</p>
                                            <p className={'pd-new-top-p2'}>Mount in portrait or landscape</p>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={24} lg={12} xl={6}>
                                    <div className={'pd-new-top-col'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37"
                                             fill="none">
                                            <g clip-path="url(#clip0_4_1420)">
                                                <path
                                                    d="M4.79591 7.39681C3.84355 6.44443 2.97672 5.57896 2.10988 4.71232C1.62908 4.2315 1.14711 3.75416 0.669777 3.27102C-0.158917 2.42987 -0.201681 1.28981 0.56229 0.532082C1.32279 -0.222169 2.46008 -0.172349 3.29918 0.667638C9.29883 6.66573 15.295 12.6661 21.2935 18.6665C26.29 23.6648 31.2852 28.6641 36.284 33.6589C36.6631 34.0377 36.959 34.4467 36.9902 35.004C37.0353 35.7965 36.6538 36.472 35.965 36.8103C35.2854 37.1439 34.4879 37.035 33.9077 36.5125C33.6396 36.2715 33.3922 36.0062 33.1368 35.7513C31.1847 33.7991 29.2314 31.8503 27.2874 29.8899C27.077 29.6779 26.8679 29.5945 26.5697 29.5945C18.9981 29.6026 11.4266 29.6026 3.85511 29.5991C1.94114 29.5991 0.449023 28.4127 0.0872641 26.6041C0.0225404 26.282 0.0213846 25.9426 0.0213846 25.6124C0.0179172 20.8714 0.0629927 16.1292 -0.000575253 11.3894C-0.0317813 9.03623 1.76083 7.26009 4.02385 7.39449C4.23767 7.40723 4.45265 7.39565 4.79591 7.39565V7.39681ZM3.75687 11.1043V25.8638H23.2433C22.4562 25.0736 21.7316 24.3367 20.9884 23.6184C20.9225 23.5547 20.7318 23.5952 20.607 23.6219C19.9748 23.7574 19.3495 24.0065 18.715 24.0297C14.6801 24.1803 11.8936 20.1936 13.3845 16.4351C13.4793 16.1964 13.4573 16.055 13.2759 15.8743C11.7572 14.3693 10.2512 12.8492 8.72788 11.3488C8.59265 11.2156 8.36034 11.1229 8.16964 11.1159C7.41954 11.0893 6.66712 11.1055 5.91586 11.1055C5.19581 11.1055 4.47692 11.1055 3.75571 11.1055L3.75687 11.1043Z"
                                                    fill="white"/>
                                                <path
                                                    d="M33.3143 11.1046C33.0958 11.1046 32.9259 11.1046 32.7572 11.1046C28.1052 11.1046 23.4531 11.1104 18.8011 11.093C18.3966 11.0918 17.9562 11.0072 17.5968 10.8323C16.8583 10.4731 16.5185 9.60302 16.7115 8.80358C16.8975 8.03427 17.5922 7.44801 18.3908 7.40167C18.6786 7.38545 18.9687 7.39588 19.2577 7.39588C23.9097 7.39588 28.5617 7.3924 33.2137 7.39819C35.0884 7.40051 36.5724 8.60082 36.933 10.3978C36.9896 10.6782 36.9966 10.9725 36.9977 11.2598C37.0012 16.0866 37.0023 20.9145 36.9977 25.7412C36.9966 27.1084 35.9621 27.9843 34.7139 27.6923C33.9522 27.515 33.379 26.843 33.3247 26.0575C33.3119 25.8698 33.3143 25.6821 33.3143 25.4944C33.3143 20.8843 33.3143 16.2731 33.3143 11.663V11.1034V11.1046Z"
                                                    fill="white"/>
                                                <path
                                                    d="M27.7688 16.6584C28.7928 16.6631 29.6111 17.488 29.6053 18.5111C29.5995 19.5306 28.7708 20.3451 27.7445 20.3405C26.7216 20.3347 25.8952 19.5028 25.9045 18.4879C25.9137 17.4683 26.7424 16.655 27.7688 16.6596V16.6584Z"
                                                    fill="white"/>
                                                <path
                                                    d="M9.24167 20.3394C8.2188 20.3324 7.40282 19.504 7.41207 18.481C7.42131 17.4614 8.25116 16.6504 9.27865 16.6585C10.3015 16.6666 11.1279 17.5031 11.1129 18.5169C11.0978 19.54 10.2703 20.3463 9.24167 20.3394Z"
                                                    fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4_1420">
                                                    <rect width="37" height="37" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <div className={'pd-new-top-div'}>
                                            <p className={'pd-new-top-p1'}>NO SUBSCRIPTION COSTS</p>
                                            <p className={'pd-new-top-p2'}>No ongoing monthly payments</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row
                                style={{
                                    // backgroundColor: '#f4f4f4',
                                    // margin: '0 8vw 0 8vw',
                                    margin: 0,
                                    width: '100%',
                                    maxWidth: maxLimitTop,
                                    // columnGap: '4rem'
                                    justify: 'center',
                                    // backgroundColor: 'green'
                                }}
                            >

                                <Col xl={12} lg={24} md={24}>
                                    <div style={{paddingTop: '2rem'}}>
                                        <VerticalCarousel>
                                        </VerticalCarousel>
                                    </div>
                                </Col>
                                <Col xl={12} lg={22} md={22}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row-reverse',
                                        // paddingBottom: '30px',
                                        paddingTop: '1.5rem'
                                    }}>
                                        <div className="spacer"></div>
                                        <div style={{}}>

                                            <p style={{
                                                margin: 0,
                                                ...TitleFont
                                            }}>
                                                Textura Digital Canvas
                                            </p>
                                            <p style={{
                                                // marginTop: "-40px",
                                                marginBottom: "-3px",
                                                fontFamily: "proxima-nova, sans-serif",
                                                fontWeight: '600',
                                                fontSize: '1.1rem'
                                            }}>
                                                Bring art into your home through the power of technology.
                                            </p>
                                            <p style={{
                                                color: 'black',
                                                fontFamily: "proxima-nova, sans-serif",
                                                fontWeight: "800",
                                                fontSize: '1.2vw',
                                                margin: '-7px 0'
                                            }}>
                                                £599
                                            </p>

                                            <p style={{
                                                ...PrimaryFont,
                                                fontWeight: "400",
                                                fontSize: '1.2rem',
                                                color: '#C6C6C6',
                                                margin: '3px 0'
                                            }}>
                                                PRICE INCLUDES VAT
                                            </p>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                marginBottom: '30px'
                                            }}>
                                                {[...Array(5)].map(() => <StarFilled
                                                    style={{fontSize: '1rem', marginRight: '10px'}}/>)}
                                                <div onClick={() => scrollDown("#REVIEWS")}
                                                     style={{
                                                         cursor: "pointer",
                                                         fontStyle: 'italic',
                                                         fontFamily: "proxima-nova, sans-serif",
                                                         fontWeight: '600',
                                                         fontSize: '0.9rem'
                                                     }}>Read Reviews
                                                </div>
                                            </div>
                                            <ul style={{
                                                margin: '0 0 30px -1vw',
                                                fontSize: '1rem',
                                                // width: '28rem',
                                                fontFamily: "proxima-nova, sans-serif",
                                            }}>
                                                <li>27” specialised digital art canvas</li>
                                                <li>FREE flush landscape/portrait wall mount included</li>
                                                <li>Access to an extensive art library and marketplace</li>
                                                <li>No ongoing subscription costs</li>
                                                <li>Display your own photos and videos</li>
                                                <li>FREE SHIPPING WORLDWIDE* (limited time only) - shipped within 2
                                                    working
                                                    days
                                                </li>
                                            </ul>

                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                paddingBottom: '1rem'
                                            }}>
                                                <button
                                                    className={this.state.color === 'a' ?
                                                        'color-btn black-btn color-btn-active' : 'color-btn black-btn'}
                                                    value="a"
                                                    style={{
                                                        backgroundColor: "black",
                                                        marginRight: '0.5rem'
                                                    }}
                                                    onClick={(e) => {
                                                        document.getElementById('thumbnail-1').click();
                                                        this.setState({color: e.target.value});
                                                    }}>
                                                </button>
                                                <button
                                                    className={this.state.color === 'd' ?
                                                        'color-btn walnut-btn color-btn-active' : 'color-btn walnut-btn'}
                                                    value="d"
                                                    style={{
                                                        backgroundColor: "#773f1a",
                                                        marginRight: '0.5rem'
                                                    }}
                                                    onClick={(e) => {
                                                        document.getElementById('thumbnail-4').click();
                                                        this.setState({color: e.target.value});
                                                    }}>
                                                </button>

                                                <button className={this.state.color === 'c' ?
                                                    'color-btn pine-btn color-btn-active' : 'color-btn pine-btn'}
                                                        value="c"
                                                        style={{
                                                            backgroundColor: "#eed5ae",
                                                            marginRight: '1rem'
                                                        }}
                                                        onClick={(e) => {
                                                            document.getElementById('thumbnail-3').click();
                                                            this.setState({color: e.target.value});
                                                        }}>
                                                </button>

                                                <span style={{
                                                    fontSize: '0.9rem',
                                                    fontFamily: "proxima-nova, sans-serif",
                                                    fontWeight: '600'
                                                }}>
                                        {COLOR_CODE[this.state.color].toString().toUpperCase()}
                                            </span>
                                            </div>

                                            <button type="submit"
                                                    className={"pay-button"}
                                                    onClick={this.checkOut}
                                                    style={{
                                                        marginTop: '1em',
                                                        fontFamily: "proxima-nova, sans-serif",
                                                        fontWeight: '800',
                                                        borderRadius: "5px",
                                                        padding: '0.5em',
                                                        width: '100%'
                                                    }}
                                            >
                                                BUY NOW
                                            </button>
                                        </div>
                                        <div className="spacer min-40px-gap-on-lg-screen"></div>
                                    </div>
                                    {/*<div style={{display: 'flex', flexDirection: 'row-reverse', paddingBottom: '30px', paddingTop: '2rem'}}>*/}
                                        {/*    <div style={{padding: '0 10px'}}>*/}
                                        {/*        <p style={{*/}
                                        {/*            margin: 0,*/}
                                        {/*            ...TitleFont*/}
                                        {/*        }}>*/}
                                        {/*            Textura Digital Canvas*/}
                                        {/*        </p>*/}
                                        {/*        <p style={{*/}
                                        {/*            // marginTop: "-40px",*/}
                                        {/*            marginBottom: "-3px",*/}
                                        {/*            fontFamily: "proxima-nova, sans-serif",*/}
                                        {/*            fontWeight: '600',*/}
                                        {/*            fontSize: '1.1rem'*/}
                                        {/*        }}>*/}
                                        {/*            Bring art into your home through the power of technology.*/}
                                        {/*        </p>*/}
                                        {/*        <p style={{*/}
                                        {/*            color: 'black',*/}
                                        {/*            fontFamily: "proxima-nova, sans-serif",*/}
                                        {/*            fontWeight: "800",*/}
                                        {/*            fontSize: '1.2vw',*/}
                                        {/*            margin: '-7px 0'*/}
                                        {/*        }}>*/}
                                        {/*            £599*/}
                                        {/*        </p>*/}

                                        {/*        <p style={{*/}
                                        {/*            ...PrimaryFont,*/}
                                        {/*            fontWeight: "400",*/}
                                        {/*            fontSize: '1.2rem',*/}
                                        {/*            color: '#C6C6C6',*/}
                                        {/*            margin: '3px 0'*/}
                                        {/*        }}>*/}
                                        {/*            PRICE INCLUDES VAT*/}
                                        {/*        </p>*/}
                                        {/*        <div style={{*/}
                                        {/*            display: 'flex',*/}
                                        {/*            flexDirection: 'row',*/}
                                        {/*            alignItems: 'center',*/}
                                        {/*            marginBottom: '30px'*/}
                                        {/*        }}>*/}
                                        {/*            {[...Array(5)].map(() => <StarFilled*/}
                                        {/*                style={{fontSize: '1rem', marginRight: '10px'}}/>)}*/}
                                        {/*            <div onClick={() => scrollDown("#REVIEWS")}*/}
                                        {/*                 style={{*/}
                                        {/*                     cursor: "pointer",*/}
                                        {/*                     fontStyle: 'italic',*/}
                                        {/*                     fontFamily: "proxima-nova, sans-serif",*/}
                                        {/*                     fontWeight: '600',*/}
                                        {/*                     fontSize: '0.9rem'*/}
                                        {/*                 }}>Read Reviews*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*        <ul style={{*/}
                                        {/*            margin: '0 0 30px -1vw',*/}
                                        {/*            fontSize: '1rem',*/}
                                        {/*            // width: '28rem',*/}
                                        {/*            fontFamily: "proxima-nova, sans-serif",*/}
                                        {/*        }}>*/}
                                        {/*            <li>27” specialised digital art canvas</li>*/}
                                        {/*            <li>FREE flush landscape/portrait wall mount included</li>*/}
                                        {/*            <li>Access to an extensive art library and marketplace</li>*/}
                                        {/*            <li>No ongoing subscription costs</li>*/}
                                        {/*            <li>Display your own photos and videos</li>*/}
                                        {/*            <li>FREE SHIPPING WORLDWIDE* (limited time only) - shipped within 2 working*/}
                                        {/*                days*/}
                                        {/*            </li>*/}
                                        {/*        </ul>*/}

                                        {/*        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingBottom: '1rem'}}>*/}
                                        {/*            <button*/}
                                        {/*                className={this.state.color === 'a' ?*/}
                                        {/*                    'color-btn black-btn color-btn-active' : 'color-btn black-btn'}*/}
                                        {/*                value="a"*/}
                                        {/*                style={{*/}
                                        {/*                    backgroundColor: "black",*/}
                                        {/*                    marginRight: '0.5rem'*/}
                                        {/*                }}*/}
                                        {/*                onClick={(e) => {*/}
                                        {/*                    document.getElementById('thumbnail-1').click();*/}
                                        {/*                    this.setState({color: e.target.value});*/}
                                        {/*                }}>*/}
                                        {/*            </button>*/}
                                        {/*            <button*/}
                                        {/*                className={this.state.color === 'd' ?*/}
                                        {/*                    'color-btn walnut-btn color-btn-active' : 'color-btn walnut-btn'}*/}
                                        {/*                value="d"*/}
                                        {/*                style={{*/}
                                        {/*                    backgroundColor: "#773f1a",*/}
                                        {/*                    marginRight: '0.5rem'*/}
                                        {/*                }}*/}
                                        {/*                onClick={(e) => {*/}
                                        {/*                    document.getElementById('thumbnail-4').click();*/}
                                        {/*                    this.setState({color: e.target.value});*/}
                                        {/*                }}>*/}
                                        {/*            </button>*/}

                                        {/*            <button className={this.state.color === 'c' ?*/}
                                        {/*                'color-btn pine-btn color-btn-active' : 'color-btn pine-btn'}*/}
                                        {/*                    value="c"*/}
                                        {/*                    style={{*/}
                                        {/*                        backgroundColor: "#eed5ae",*/}
                                        {/*                        marginRight: '1rem'*/}
                                        {/*                    }}*/}
                                        {/*                    onClick={(e) => {*/}
                                        {/*                        document.getElementById('thumbnail-3').click();*/}
                                        {/*                        this.setState({color: e.target.value});*/}
                                        {/*                    }}>*/}
                                        {/*            </button>*/}

                                        {/*            <span style={{*/}
                                        {/*                fontSize: '0.9rem',*/}
                                        {/*                fontFamily: "proxima-nova, sans-serif",*/}
                                        {/*                fontWeight: '600'*/}
                                        {/*            }}>*/}
                                        {/*    {COLOR_CODE[this.state.color].toString().toUpperCase()}*/}
                                        {/*        </span>*/}
                                        {/*        </div>*/}

                                        {/*        <button type="submit"*/}
                                        {/*                className={"pay-button"}*/}
                                        {/*                onClick={this.checkOut}*/}
                                        {/*                style={{*/}
                                        {/*                    marginTop: '1em',*/}
                                        {/*                    fontFamily: "proxima-nova, sans-serif",*/}
                                        {/*                    fontWeight: '800',*/}
                                        {/*                    borderRadius: "5px",*/}
                                        {/*                    padding: '0.5em',*/}
                                        {/*                    width: '100%'*/}
                                        {/*                }}*/}
                                        {/*        >*/}
                                        {/*            BUY NOW*/}
                                        {/*        </button>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="spacer min-40px-gap-on-lg-screen" ></div>*/}
                                        {/*</div>*/}
                                </Col>
                            </Row>
                        </div>


                        {/*Product Row*/}


                        {/*Others*/}
                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#f4f4f4',
                                 paddingTop: '3rem',
                             }}
                        >
                            <Col lg={20} xs={20}>
                                <div className="video-container">
                                    <Image
                                        height={'100%'}
                                        width={'100%'}
                                        src={Transforming_Img}
                                        preview={false}
                                        style={{
                                            borderRadius: '15px',
                                            objectFit: 'cover',
                                            // objectPosition: 'top',
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#f4f4f4',
                                 paddingTop: '1.5rem',
                                 paddingBottom: '4rem'
                             }}
                        >
                            <Col lg={10} xs={20} style={{
                                alignItems: "center"
                            }}>
                                <div className="text-container m-title-small"
                                     style={{}}>
                                    <p style={{
                                        ...TitleFont,
                                        fontWeight: 700,
                                        marginRight: '40px',
                                        marginBottom: 0
                                    }}>
                                        Transforming the World Around You.
                                    </p>
                                </div>
                            </Col>

                            <Col lg={10} xs={20}>
                                <div className="text-container">
                                    <p style={{fontFamily: "proxima-nova, sans-serif", fontSize: '1rem'}}>
                                        {TEXTURA_TEXT["Transforming the World Around You"]}
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        {/*Left-Img-Right-Text Section*/}
                        <Row style={{
                            backgroundColor: 'black',
                            // paddingBottom: '2rem',
                            padding: 0,
                            overflow: "hidden"
                        }}
                             className={"img-text-zone"}
                        >
                            <Col span={10} lg={10} xs={0}>
                                <div className="video-container"
                                     style={{marginLeft: '0', marginBottom: '-10%'}}>
                                    <Image
                                        src={LifeLike_Img}
                                        preview={false}
                                    />
                                </div>
                            </Col>

                            <Col span={0} lg={0} xs={24}>
                                <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                                    <img
                                        style={{maxHeight: '40rem', maxWidth: '100%', objectFit: 'contain'}}
                                        src={mLifeLike_Img}
                                    />
                                </div>
                            </Col>
                            <Col span={10} lg={10} xs={20}>
                                <div style={{
                                    paddingLeft: '10%',
                                    // paddingBottom: '5rem',
                                    // backgroundColor: 'red',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '110%',
                                    height: '100%'
                                }}>
                                    <div className='spacer' style={{minHeight: '30px'}}></div>
                                    <h2 className="title-app"
                                        style={{
                                            color: 'white', ...TitleFont,
                                            marginBottom: 0
                                        }}>
                                        Lifelike Textures.
                                    </h2>
                                    <p className="text-content-app"
                                       style={{
                                           color: 'white',
                                           fontFamily: "proxima-nova, sans-serif",
                                           fontWeight: '500',
                                       }}>
                                        {TEXTURA_TEXT['Lifelike Textures']}
                                    </p>
                                    <div className='spacer' style={{minHeight: '30px'}}></div>
                                </div>
                            </Col>
                        </Row>

                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#ececec',
                                 margin: "5rem 8vw 0 8vw",
                                 borderRadius: '15px',
                                 overflow: 'hidden'
                             }}
                        >
                            <Col
                                span={12}
                                lg={12}
                                xs={24}
                                // xs={}
                                style={{
                                    textAlign: "center",
                                }}>
                                <div style={{
                                    marginLeft: '10%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%'
                                }}>
                                    <div className='spacer' style={{minHeight: '30px'}}></div>
                                    <h2 className="title-app"
                                        style={{
                                            color: 'black',
                                            ...TitleFont,
                                            textAlign: 'left',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }}
                                    >
                                        Made for You.
                                    </h2>
                                    <p className="text-content-app" style={{color: 'black', width: '80%'}}>
                                        {TEXTURA_TEXT["Made for You"]}
                                    </p>
                                    <div className='spacer' style={{minHeight: '30px'}}></div>
                                </div>
                            </Col>
                            <Col span={12} lg={{span: 12}} xs={24} style={{
                                backgroundColor: '#ececec'
                            }}>
                                <div className="video-container" style={{display: "flex"}}>
                                    <Image
                                        src={MadeForYou_Img}
                                        preview={false}
                                        style={{
                                            borderTopRightRadius: '15px',
                                            borderBottomRightRadius: '15px',
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#ececec',
                                 margin: "5rem 8vw 0 8vw",
                                 borderRadius: "15px",
                                 overflow: "hidden"
                             }}
                        >
                            <Col span={10} lg={{span: 10}} xs={24}>
                                <img
                                    src={InstallsEasy_Img}
                                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                    preview={false}
                                />
                            </Col>

                            <Col span={14} lg={14} xs={24}>
                                <div style={{marginLeft: '10%', display: 'flex', flexDirection: 'column', height: '100%'}}>
                                    <div className='spacer' style={{minHeight: '30px'}}></div>
                                    <h2 className="title-app"
                                        style={{
                                            color: 'black',
                                            ...TitleFont,
                                            textAlign: 'left',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }}
                                    >
                                        Installs made easy.
                                    </h2>
                                    <p className="text-content-app"
                                       style={{color: 'black', width: '80%'}}>
                                        {TEXTURA_TEXT["Installs made easy"]}
                                    </p>
                                    <div className='spacer' style={{minHeight: '30px'}}></div>
                                </div>
                            </Col>

                        </Row>

                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#2c2e2d',
                                 margin: "5rem 8vw 0 8vw",
                                 borderRadius: "15px",
                                 overflow: 'hidden'
                             }}
                        >
                            <Col span={13} lg={13}
                                 xs={24}>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                    margin: "0 3rem",

                                }}>
                                    <div className="spacer"></div>
                                    <h2 className="title-app"
                                        style={{
                                            color: 'white',
                                            ...TitleFont,
                                            textAlign: 'left',
                                            lineHeight: 1,
                                            marginBottom: 0,
                                            marginTop: '3rem'
                                        }}
                                    >
                                        The Vieunite App.
                                    </h2>
                                    <p className="text-content-app"
                                       style={{color: 'white', width: '80%', lineHeight: 1.3}}>
                                        {TEXTURA_TEXT["The Vieunite App 1"]}
                                    </p>
                                    <p className="text-content-app"
                                       style={{color: 'white', width: '80%', lineHeight: 1.3}}>
                                        {TEXTURA_TEXT["The Vieunite App 2"]}
                                    </p>

                                    <div style={{
                                        // display: "flex",
                                        // justifyContent: "",
                                        // backgroundColor: 'red',
                                        // alignItems: "flex-start",
                                        margin: "0 0 3rem 0"
                                    }}>
                                        <button className="homeMainButton"
                                                style={{width: "19rem", marginRight: "2rem", marginBottom: '1rem'}}>
                                            <a className={'homeMainButtonLnk homeOverV'} href="/digital-canvas">
                                                IOS
                                            </a>
                                        </button>
                                        <button className="homeMainButton"
                                                style={{width: "19rem", marginRight: "2rem"}}>
                                            <a className={'homeMainButtonLnk homeOverV'} href="/digital-canvas">
                                                GOOGLE PLAY
                                            </a>
                                        </button>
                                    </div>
                                </div>
                            </Col>

                            <Col span={11} lg={{span: 11}} xs={24} style={{
                                backgroundColor: '#2c2e2d',
                            }}>
                                <div className="video-container" style={{display: "flex"}}>
                                    <video playsInline loop autoPlay ref={makeMuted} muted rel={"preload"} style={{
                                        width: '100%',
                                        minHeight: '75vh',
                                        height: 'auto',
                                        objectFit: "cover"
                                    }}>
                                        <source src={Vieunite_App_Vd2}></source>
                                    </video>
                                </div>
                            </Col>
                        </Row>

                        {/*Phone Section*/}
                        {/*<Row justify={"center"}*/}
                        {/*     style={{*/}
                        {/*         backgroundColor: '#f4f4f4',*/}
                        {/*     }}*/}
                        {/*     className={"img-text-zone m-img-text"}*/}
                        {/*>*/}
                        {/*    <Col className={'m-padding-tb'} span={10} lg={10} xs={{...MWidth}}>*/}
                        {/*        <div className="video-container"*/}
                        {/*             style={{*/}
                        {/*                 background: 'linear-gradient(0deg, rgba(172,203,238,1) 4%, rgba(231,240,253,1) 100%)',*/}
                        {/*                 borderRadius: '5px',*/}
                        {/*             }}>*/}
                        {/*            <Image*/}
                        {/*                src={Textura_App_Img}*/}
                        {/*                preview={false}*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col span={10} lg={{span: 10, offset: 1}} xs={{...MWidth}}>*/}
                        {/*        <div className="vertical-center-text" style={{margin: '0 0 0 0'}}>*/}
                        {/*            <h2 className="title-app" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                ...TitleFont*/}
                        {/*            }}>*/}
                        {/*                Smart Screen for Your Smart Home.*/}
                        {/*            </h2>*/}
                        {/*            <p className="text-content-app" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                fontFamily: "proxima-nova, sans-serif",*/}
                        {/*                fontWeight: '500',*/}
                        {/*            }}>*/}
                        {/*                {TEXTURA_TEXT["Smart Screen for Your Smart Home"]}*/}
                        {/*            </p>*/}
                        {/*            <Row>*/}
                        {/*                <button type="submit"*/}
                        {/*                        className={"pay-button"}*/}
                        {/*                        onClick={() => {*/}
                        {/*                            window.location.href = 'https://apps.apple.com/gb/app/vieunite/id1644381065'*/}
                        {/*                        }}*/}
                        {/*                        style={{*/}
                        {/*                            marginTop: '1em', fontFamily: "proxima-nova, sans-serif",*/}
                        {/*                            fontWeight: '800',*/}
                        {/*                            borderRadius: "10px",*/}
                        {/*                            padding: '1em 0 1em 0',*/}
                        {/*                        }}*/}

                        {/*                >*/}
                        {/*                    IOS APP STORE*/}
                        {/*                </button>*/}
                        {/*            </Row>*/}
                        {/*            <Row>*/}
                        {/*                <button type="submit"*/}
                        {/*                        className={"pay-button"}*/}
                        {/*                        onClick={() => {*/}
                        {/*                            window.location.href = 'https://play.google.com/store/apps/details?id=com.app.vieunite&gl=GB'*/}
                        {/*                        }}*/}
                        {/*                        style={{*/}
                        {/*                            marginTop: '1em', fontFamily: "proxima-nova, sans-serif",*/}
                        {/*                            fontWeight: '800', borderRadius: "10px",*/}
                        {/*                            padding: '1em 0 1em 0',*/}
                        {/*                        }}*/}
                        {/*                >*/}
                        {/*                    GOOGLE PLAY STORE*/}
                        {/*                </button>*/}
                        {/*            </Row>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}


                        {/*Four Intro Cols*/}
                        {/*<Row justify={"space-evenly"}*/}
                        {/*     style={{*/}
                        {/*         backgroundColor: '#f4f4f4',*/}
                        {/*         flexWrap: 'wrap'*/}
                        {/*     }}*/}
                        {/*     className={"img-text-zone"}*/}
                        {/*>*/}
                        {/*    <Col span={9} lg={4} xs={{...MWidth / 2}}>*/}
                        {/*        <div className="text-container ">*/}
                        {/*            <h2 className="title-app primary-font" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                display: "flex",*/}
                        {/*                justifyContent: "center",*/}
                        {/*                fontSize: '25px',*/}
                        {/*            }}>*/}
                        {/*                Simplicity*/}
                        {/*            </h2>*/}
                        {/*            <p className="text-content-app primary-font m-small-txt" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                textAlign: "center", fontSize: '17px',*/}
                        {/*            }}>*/}
                        {/*                {TEXTURA_TEXT["Simplicity"]}*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col span={8} lg={4} xs={{...MWidth / 2}}>*/}
                        {/*        <div className="text-container ">*/}
                        {/*            <h2 className="title-app" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                display: "flex",*/}
                        {/*                justifyContent: "center",*/}
                        {/*                fontSize: '25px',*/}
                        {/*            }}>*/}
                        {/*                Accuracy*/}
                        {/*            </h2>*/}
                        {/*            <p className="text-content-app m-small-txt" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                textAlign: "center",*/}
                        {/*                fontSize: '17px',*/}
                        {/*            }}>*/}
                        {/*                {TEXTURA_TEXT["Accuracy"]}*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col span={9} lg={4} xs={{...MWidth / 2}}>*/}
                        {/*        <div className="text-container ">*/}
                        {/*            <h2 className="title-app" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                display: "flex",*/}
                        {/*                justifyContent: "center",*/}
                        {/*                fontSize: '25px',*/}
                        {/*            }}>*/}
                        {/*                Efficiency*/}
                        {/*            </h2>*/}
                        {/*            <p className="text-content-app m-small-txt" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                textAlign: "center",*/}
                        {/*                fontSize: '17px',*/}
                        {/*            }}>*/}
                        {/*                {TEXTURA_TEXT["Efficiency"]}*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col span={8} lg={4} xs={{...MWidth / 2}}>*/}
                        {/*        <div className="text-container ">*/}
                        {/*            <h2 className="title-app" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                display: "flex",*/}
                        {/*                justifyContent: "center",*/}
                        {/*                fontSize: '25px',*/}
                        {/*            }}>*/}
                        {/*                Transparency*/}
                        {/*            </h2>*/}
                        {/*            <p className="text-content-app m-small-txt" style={{*/}
                        {/*                color: 'black',*/}
                        {/*                textAlign: "center",*/}
                        {/*                fontSize: '17px',*/}
                        {/*            }}>*/}
                        {/*                {TEXTURA_TEXT["Transparency"]}*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}

                        { /* Product Reviews*/}
                        <Row className={'m-img-art'} justify={'center'}
                             style={{padding: '5rem 0 1rem 0', background: '#f4f4f4'}}>
                            <Col span={10} lg={{span: 20}} xs={20}>
                                <h2 className="title-app mobile-left"
                                    style={{textAlign: "left", ...TitleFont}}>
                                    Product Reviews
                                </h2>
                            </Col>
                        </Row>
                        <Row gutter={[16, 8]}  style={{background: '#f4f4f4', margin: "0 8vw 0 8vw"}}>
                            <Col span={8} lg={8} xs={24}>
                                <div className="product-reviews-square" style={{margin: 0}}>
                                    <div className="product-reviews-logo">
                                        <img style={{objectFit: "none"}}
                                             src={Textura_App_product_review_Img_1}></img>
                                    </div>

                                    <div className="product-reviews-stars">
                                        <img style={{objectFit: "none"}}
                                             src={TexturaStars}></img>
                                    </div>

                                    <p>“The Vieunite Textura Digital Canvas dwarfs standard digital photo frames for
                                        size
                                        and is next-level in almost every regard thanks to its ultra high-quality
                                        27-inch
                                        display . . . “</p>
                                </div>

                            </Col>
                            <Col span={8} lg={8} xs={24}>
                                <div className="product-reviews-square" style={{margin: 0}}>
                                    <div className="product-reviews-logo">
                                        <img style={{objectFit: "none"}}
                                             src={Textura_App_product_review_Img_2}></img>
                                    </div>
                                    <div style={{height: '30px'}}></div>
                                    <p>“We love that this frame gives us the ultimate flexibility in what we display on our wall . . .”</p>
                                </div>

                            </Col>
                            <Col span={8} lg={8} xs={24}>
                                <div className="product-reviews-square" style={{margin: 0}}>
                                    <div className="product-reviews-logo">
                                        <img style={{objectFit: "none"}}
                                             src={Textura_App_product_review_Img_3}></img>
                                    </div>

                                    <div className="product-reviews-stars">
                                        <img style={{objectFit: "none"}}
                                             src={TexturaStars}></img>
                                    </div>

                                    <p>“The Vieunite Textura Digital Canvas not only looks good and has a beautiful
                                        screen,
                                        but it becomes a portal to a new world of artists, right there in your home. . .
                                        .
                                        “</p>
                                </div>

                            </Col>
                        </Row>

                        { /* Video Reviews*/}
                        <Row className={'m-img-art'} justify={'center'}
                             style={{padding: '6rem 0 1rem 0', background: '#f4f4f4'}}>
                            <Col span={10} lg={{span: 20}} xs={20}>
                                <h2 className="title-app mobile-left"
                                    style={{textAlign: "left", ...TitleFont}}>
                                    Video Reviews
                                </h2>
                                <p className="text-content-app mobile-left artist-text"
                                   style={{
                                       ...PrimaryFont, fontWeight: '500',
                                       fontSize: '1rem', marginTop: '-1rem'
                                   }}>
                                    All video reviews featured are independent and have not been compensated by Vieunite.
                                </p>
                            </Col>
                        </Row>

                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#E7E7E7',
                                 margin: "0 8vw 0 8vw",
                                 borderRadius: "15px",
                                 overflow: "hidden",
                                 height: "auto"
                             }}
                        >
                            <Col span={10} lg={10} xs={24}>
                                <div style={{
                                    marginLeft: '10%',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <div className='spacer' style={{minHeight: '40px'}}></div>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}>
                                        <img src={YouTubeLogo}/>
                                        <h2 className="title-app"
                                            style={{
                                                ...TitleFont,
                                                fontSize: '2rem',
                                                textAlign: 'left',
                                                lineHeight: 1,
                                                margin: "0 1rem"
                                            }}
                                        >
                                            Tech Spurt
                                        </h2>
                                    </div>

                                    <p className="text-content-app"
                                       style={{width: '100%', marginRight: '2rem'}}>
                                        Aliquam gravida dolor sollicitudin dapibus consectetur. Suspendisse a ornare
                                        mi. In efficitur varius tortor non pharetra. Vestibulum leo ligula, mollis sed
                                        enim a, interdum viverra nibh. Sed suscipit lobortis
                                        Watch Full Video
                                    </p>
                                    <div className='spacer'></div>
                                </div>

                            </Col>

                            <Col span={14} lg={{span: 14}} xs={24}>
                                <div className="iframe-container">
                                    <iframe width="608" height="342"
                                            src="https://www.youtube.com/embed/8BgRHPt6vSE?si=mSxdRVNJTknmb7kn"
                                            title="YouTube video player" frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                                            style={{margin: "4rem 2rem"}}
                                    ></iframe>
                                </div>

                            </Col>
                        </Row>


                        {/*Google Reviews*/}
                        <Row className={'m-img-art'} justify={'center'}
                             id={'REVIEWS'}
                             style={{padding: '5rem 0 1rem 0', background: '#f4f4f4'}}>
                            <Col span={10} lg={{span: 20}} xs={20}>
                                <h2 className="title-app mobile-left"
                                    style={{textAlign: "left", ...TitleFont}}>
                                    Customer Reviews
                                </h2>
                                <p className="text-content-app mobile-left artist-text"
                                   style={{
                                       ...PrimaryFont, fontWeight: '500',
                                       fontSize: '1rem', marginTop: '-1rem'
                                   }}>
                                    Read reviews of Vieunite on <a
                                    href='https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LLZMyU6vNC02YLRSNagwsTA3sDQ3T022MDA1MDYxtTKosDQ0TTFOTjGyTEu0NDVKsfDiKMtMLc3LLEkFADVZEi0&q=vieunite&rlz=1C5CHFA_enGB1000GB1000&oq=vieunite&aqs=chrome.1.69i60j46i175i199i512j35i39j0i512j69i60l4.3900j0j7&sourceid=chrome&ie=UTF-8'
                                    style={{color: "black", textDecoration: "underline"}}>Google</a>.
                                </p>
                            </Col>
                        </Row>
                        <Row justify={"center"} align={"top"}
                             style={{background: '#f4f4f4', columnGap: '1rem', paddingBottom: '4rem'}}>
                            {/*Left part*/}
                            <Col span={20} lg={10} xs={{...MWidth}} style={{
                                backgroundColor: '#f4f4f4',
                                // paddingBottom: '2.75rem',
                                // paddingTop: '2.75rem',
                            }}>
                                <Space direction={"vertical"} size={'large'}>
                                    <ReviewCard reviewer={Reviews[0]}></ReviewCard>
                                    <ReviewCard reviewer={Reviews[1]}></ReviewCard>
                                    <ReviewCard reviewer={Reviews[2]}></ReviewCard>
                                </Space>
                            </Col>

                            {/*Right part*/}
                            <Col className={'right-review-card'} span={20} lg={10} xs={{...MWidth}} style={{
                                backgroundColor: '#f4f4f4',
                            }}>
                                <ReviewCard reviewer={Reviews[3]}></ReviewCard>
                            </Col>
                        </Row>

                        {/*Collapsable Sections*/}
                        <Row justify={"center"}
                             style={{
                                 backgroundColor: '#f4f4f4',
                             }}>
                            <Col span={20} lg={20} md={20}>
                                <Collapse expandIconPosition={"end"}
                                          bordered={false}
                                          style={{
                                              backgroundColor: '#f4f4f4',
                                              color: '#f4f4f4',
                                              border: "none"
                                          }}
                                          expandIcon={() => <PlusOutlined style={{
                                              fontSize: '24px', fontWeight: "900",
                                          }}/>}
                                >
                                    <Panel header="Specification"
                                           style={{
                                               fontSize: '24px', fontWeight: "700",
                                           }}
                                           key="1">

                                        <i className="specification-section-title">Physical Specification</i>
                                        <br/>
                                        <b className="specification-title">Display Size</b>
                                        <p className="specification-body">27 Inches</p>
                                        <b className="specification-title">Brightness</b>
                                        <p className="specification-body">50 - 250 nits</p>
                                        <b className="specification-title">Resolution</b>
                                        <p className="specification-body">1920x1080</p>
                                        <b className="specification-title">Speakers</b>
                                        <p className="specification-body">1.5W, 8Ω (x2)</p>
                                        <b className="specification-title">Canvas Orientation</b>
                                        <p className="specification-body">Portrait/Landscape</p>
                                        <b className="specification-title">Canvas Size</b>
                                        <p className="specification-body">711.1x449.7x33.95mm</p>
                                        <b className="specification-title">Net Weight</b>
                                        <p className="specification-body">6Kg</p>
                                        <b className="specification-title">Gross Weight</b>
                                        <p className="specification-body">8.42Kg</p>
                                        <b className="specification-title">Package Size</b>
                                        <p className="specification-body">820x545x145mm</p>
                                        <br/>
                                        <i className="specification-section-title">Technical Specification</i>
                                        <br/>
                                        <b className="specification-title">CPU</b>
                                        <p className="specification-body">UNISOC UIS8581 /8 Core Cortex A55</p>
                                        <b className="specification-title">RAM</b>
                                        <p className="specification-body">2GB LPDDR4</p>
                                        <b className="specification-title">Storage</b>
                                        <p className="specification-body">32GB eMMC</p>
                                        <b className="specification-title">Control</b>
                                        <p className="specification-body">Vieunite App</p>
                                        <b className="specification-title">Supported Formats</b>
                                        <p className="specification-body">Image (Jpg), Video (MPG, AVI, MP4)</p>
                                    </Panel>
                                    <Panel header="Description"
                                           style={{
                                               fontSize: '24px', fontWeight: "700",
                                           }}
                                           key="2">
                                        <p>{PRODUCT_TEXT.Description}</p>
                                        <p>{PRODUCT_TEXT.Description_Dimensions}</p>
                                    </Panel>
                                    <Panel header="Delivery" key="3" style={{
                                        fontSize: '24px', fontWeight: "700",
                                    }}>
                                        <p>{PRODUCT_TEXT.Delivery}</p>
                                    </Panel>
                                    <Panel header="Return Policy" key="4" style={{
                                        fontSize: '24px', fontWeight: "700",
                                    }}>
                                        <p>
                                            {PRODUCT_TEXT["Return Policy"]}
                                            <a href="mailto:info@vieunite.com"
                                               style={{color: "black", textDecoration: "underline"}}>
                                                support@vieunite.com.
                                            </a>
                                        </p>
                                    </Panel>
                                    <Panel header="In the Box" key="5" style={{
                                        fontSize: '24px', fontWeight: "700",
                                    }}>
                                        <p>{PRODUCT_TEXT["In the Box"]}</p>
                                    </Panel>
                                    <Panel header="Downloads" key="6" style={{
                                        fontSize: '24px', fontWeight: "700",
                                    }}>
                                        <a href="/Vieunite - VT27WGV1 - Version 4.0 User Manual.pdf">
                                            Vieunite - VT27WGV1 - Version 4.0 User Manual
                                        </a>
                                        <br></br>
                                        <a href="/VT27WGV1 - Technical Drawing.pdf">
                                            VT27WGV1 - Technical Drawing
                                        </a>
                                    </Panel>
                                    <Panel header="Warranty" key="7" style={{
                                        fontSize: '24px', fontWeight: "700",
                                    }}>
                                        <p>{PRODUCT_TEXT.Warranty}</p>
                                    </Panel>
                                </Collapse>
                            </Col>
                        </Row>

                        {/*Get Support Section*/}
                        <Row justify={"center"}
                             style={{
                                 backgroundColor: 'black',
                                 margin: "0 8vw 4vw 8vw",
                                 borderRadius: "15px",
                             }}
                        >
                            <div style={{padding: "3rem", display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <h2 className="title-app m-text"
                                    style={{
                                        color: 'white',
                                        display: "flex",
                                        justifyContent: "center",
                                        ...TitleFont,
                                        margin: '0 1rem',
                                    }}>
                                    Get Support.
                                </h2>
                                <p className="text-content-app m-text"
                                   style={{
                                       color: 'white',
                                       textAlign: "center",
                                       paddingLeft: '8rem',
                                       paddingRight: '8rem',
                                       // paddingTop: "1rem",
                                       // paddingBottom: "1rem",
                                       // margin: '0 1rem',
                                   }}>
                                    If you have questions about the Textura digital canvas or Vieunite app that
                                    aren't answered here,
                                    or if you encounter any issues with your product, explore our dedicated support
                                    resources or reach
                                    out to us for assistance.
                                </p>
                                <button className="homeMainButton">
                                    <a className={'homeMainButtonLnk homeOverV'} href="/digital-canvas">
                                        ACCESS SUPPORT
                                    </a>
                                </button>
                            </div>
                        </Row>
                    </Content>
                </Layout>
            </div>
        )
    }
}

export default ProductDetailsNew;
